import React from 'react';
import { Grid, Typography } from '@mui/material';
import { SparkTabs } from 'sharedComponents/UI';
import { TabItem } from 'sharedComponents/UI/SparkTabs';

import TeamMembersTab from './TeamMembersTab';
import { useLocation, useParams } from 'react-router-dom';
import { useWorkspaceByID } from 'hooks/Workspace/useWorkspaceByID';
import WorkspacesSkeleton from 'sharedComponents/Skeleton/CompainesSkeleton';
import { useResize } from 'hooks/common';
import CompanyWorkspaceSettingsTab from './CompanyWorkspaceSettingsTab';
import KnowledgeTab from './KnowledgeTab';
import { useGetCategories } from 'hooks/Categories';
import { CATEGORIES } from 'constants/common';
import PersonalWorkspaceSettingTab from './PersonalWorkspaceSettingTab';

function WorkspacesSettings() {
  const { id: workspaceID } = useParams();

  const location = useLocation();
  const selectedTabIndex = location.state?.selectedTabIndex || 0;
  const { workspace, isLoading, companyOverview, personalOverview } =
    useWorkspaceByID(workspaceID);
  const { categoryIdMap } = useGetCategories(null);
  const { isMobile } = useResize();

  const tabItems: TabItem[] = React.useMemo(() => {
    const isBusinessCategory =
      categoryIdMap?.[workspace?.attributes.categoryID || '']?.attributes
        .name === CATEGORIES.BUSINESS;
    return [
      {
        label: 'Settings',
        content: (
          <>
            {isBusinessCategory ? (
              <CompanyWorkspaceSettingsTab
                workspace={workspace}
                companyOverviewID={companyOverview?.id}
              />
            ) : (
              <PersonalWorkspaceSettingTab
                workspace={workspace}
                personalOverviewID={personalOverview?.id}
              />
            )}
          </>
        ),
      },
      {
        label: 'Knowledge',
        content: <KnowledgeTab workspaceID={workspaceID} />,
      },
      // {
      //   label: 'Team Members',
      //   content: <TeamMembersTab workspaceID={workspaceID} />,
      // },
    ];
  }, [categoryIdMap, companyOverview?.id, workspace, workspaceID]);
  if (isLoading) {
    return <WorkspacesSkeleton />;
  }
  return (
    <Grid container padding={isMobile ? 2 : 3}>
      <Grid item alignItems='center' xs={12}>
        <Typography
          variant='h4'
          sx={{
            color: '#404040',
            fontFamily: 'Mont-semibold',
          }}
        >
          {workspace?.attributes.name}
        </Typography>
      </Grid>

      <Grid container item display='flex' alignItems='center' marginTop={2}>
        <SparkTabs tabItems={tabItems} selectedItemIndex={selectedTabIndex} />
      </Grid>
    </Grid>
  );
}

export default WorkspacesSettings;
